import React, { useState } from "react";

function LoginFormV2({ handleSubmit, credentials, handleChange, loading, setShowForgotPassword }) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      {/* Username field */}
      <div className="space-y-2">
        <label
          htmlFor="username"
          className="block text-2xl font-semibold tracking-wide"
          style={{ color: "#e2e1f4" }}
        >
          Nombre de Usuario
        </label>
        <div className="relative group">
          <span
            className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-[20px] pointer-events-none transition-colors"
            style={{ color: "#d3c4ae" }}
          >
            person
          </span>
          <input
            type="text"
            id="username"
            name="username"
            value={credentials.username}
            onChange={handleChange}
            placeholder="Ingresa tu usuario"
            autoComplete="username"
            className="w-full py-3 pl-16 pr-4 rounded-lg border-[1px] border-white/20 outline-none transition-all text-sm"
            style={{
              backgroundColor: "#0c0d1a",
              color: "#e2e1f4",
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#91d0df";
              e.target.style.boxShadow = "0 0 0 2px rgba(145, 208, 223, 0.2)";
              e.target.previousElementSibling.style.color = "#91d0df";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "rgba(255,255,255,0.1)";
              e.target.style.boxShadow = "none";
              e.target.previousElementSibling.style.color = "#d3c4ae";
            }}
            required
          />
        </div>
      </div>

      {/* Password field */}
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <label
            htmlFor="password"
            className="block text-2xl font-semibold tracking-wide"
            style={{ color: "#e2e1f4" }}
          >
            Contraseña
          </label>
          <button
            type="button"
            onClick={() => setShowForgotPassword(true)}
            className="text-xl transition-colors focus:outline-none"
            style={{ color: "#91d0df" }}
            onMouseEnter={(e) => (e.target.style.color = "#b5dcff")}
            onMouseLeave={(e) => (e.target.style.color = "#91d0df")}
          >
            ¿Olvidaste tu contraseña?
          </button>
        </div>
        <div className="relative group">
          <span
            className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-[20px] pointer-events-none transition-colors"
            style={{ color: "#d3c4ae" }}
            id="lock-icon"
          >
            lock
          </span>
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            name="password"
            value={credentials.password}
            onChange={handleChange}
            placeholder="Ingresa tu contraseña"
            autoComplete="current-password"
            className="w-full py-3 pl-16 pr-12 rounded-lg border-[1px] border-white/20 outline-none transition-all text-sm"
            style={{
              backgroundColor: "#0c0d1a",
              color: "#e2e1f4",
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#91d0df";
              e.target.style.boxShadow = "0 0 0 2px rgba(145, 208, 223, 0.2)";
              document.getElementById("lock-icon").style.color = "#91d0df";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "rgba(255,255,255,0.1)";
              e.target.style.boxShadow = "none";
              document.getElementById("lock-icon").style.color = "#d3c4ae";
            }}
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            className="absolute right-3 top-1/2 -translate-y-1/2 transition-colors focus:outline-none"
            style={{ color: "#d3c4ae" }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.color = "#e2e1f4")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.color = "#d3c4ae")
            }
          >
            <span className="material-symbols-outlined text-[20px]">
              {showPassword ? "visibility" : "visibility_off"}
            </span>
          </button>
        </div>
      </div>

      {/* Submit button */}
      <div className="pt-10">
        <button
          type="submit"
          disabled={loading}
          className="w-full flex items-center justify-center gap-2 py-3 px-4 rounded-lg font-semibold text-2xl transition-all active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed"
          style={{
            backgroundColor: "#ecb236",
            color: "#634600",
          }}
          onMouseEnter={(e) => {
            if (!loading) e.currentTarget.style.opacity = "0.9";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = "1";
          }}
        >
          {loading ? (
            <>
              <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
              Iniciando sesión...
            </>
          ) : (
            <>
              Iniciar sesión
              <span className="material-symbols-outlined text-[18px]">
                arrow_forward
              </span>
            </>
          )}
        </button>
      </div>
    </form>
  );
}

export default LoginFormV2;

